import { Outlet } from 'react-router-dom'

const InitialCommunityLayout = () => {
  return <Outlet />;
}

export default InitialCommunityLayout